/**
 * Created by DynamicDog on 2016-12-13.
 */
import {Component} from '@angular/core';

@Component({
    selector: 'app-header',
    template: `
           <meta http-equiv="Cache-Control" content="no-cache, no-store, must-revalidate">
            <meta http-equiv="Pragma" content="no-cache">
            <meta http-equiv="Expires" content="0"> <div class="header">
                <div class="back"> < {{'Tillbaka till dansukker.se'|translate}} </div>
                <img class="logo" src="public/css/images/ds_logo.png">
            </div>
        `,
})
export class AppHeaderComponent {
    constructor() {

    }
}


// WEBPACK FOOTER //
// ./app/appheader.component.ts